// extracted by css-extract-rspack-plugin
export default {"cls1":"PremiumBadge-cls1_6Pi","cls2":"PremiumBadge-cls2_rz6 PremiumBadge-cls1_6Pi"};